import workspaceQuery from 'graphql/queries/nominal/NominalCustomerAccountSetWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalCustomerAccountSetListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalCustomerAccountSetQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalCustomerAccountSetDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalCustomerAccountSetMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalCustomerAccountSetFragment.graphql';

const NominalCustomerAccountSet = {
  type: 'NominalCustomerAccountSet',
  title: 'Customer Account Sets',
  formTitle: 'Customer Account Set',
  formUrl: '/Nominal/CustomerAccountSet/Details/',
  workspaceUrl: '/Nominal/CustomerAccountSet/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'code',
  },
  fragment,
  screenReference: 'NOMINAL_CUSTOMER_ACCOUNT_SET',
};

export default NominalCustomerAccountSet;
